import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';
import { useEffect } from 'react';
import { Checkbox } from 'common/form';
import { Radio, SxProps } from '@mui/material';
import { TableV3SelectionMode } from 'common/table/types/TableV3';

type TableCellSelectionCheckboxProps<T> = {
  params: ICellRendererParams<T>;
  selectionMode?: TableV3SelectionMode;
};

const radioSx: SxProps = {
  padding: 0,
  width: '25px',
  height: '25px',
  '& .MuiSvgIcon-root': {
    width: '25px',
    height: '25px'
  }
};

export const TableCellSelectionCheckbox: <T>(
  props: TableCellSelectionCheckboxProps<T>
) => React.ReactElement = ({ params, selectionMode }) => {
  const [isSelected, setIsSelected] = useState(() => {
    return params.node ? params.node.isSelected() : false;
  });

  useEffect(() => {
    if (!params.api || !params.node) {
      return;
    }

    const onSelectionChanged = () => {
      setIsSelected(params.node.isSelected());
    };

    params.api.addEventListener('selectionChanged', onSelectionChanged);

    return () => {
      if (params.api) {
        params.api.removeEventListener('selectionChanged', onSelectionChanged);
      }
    };
  }, []);

  const handleSelectionChange = (value: boolean) => {
    if (!params.api || !params.node) {
      return;
    }

    params.api.setNodesSelected({
      nodes: [params.node],
      newValue: value
    });
    setIsSelected(value);
  };

  const isSelectable = params.node?.selectable !== false;

  if (selectionMode === 'singleRow') {
    return (
      <Radio
        checked={isSelected}
        disabled={!isSelectable}
        onChange={(e) => handleSelectionChange(e.target.checked)}
        sx={radioSx}
      />
    );
  }

  return (
    <Checkbox
      value={isSelected}
      field={{ disabled: !isSelectable }}
      onChange={handleSelectionChange}
    />
  );
};
